import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import { LockIcon } from 'components/Utils/Icons'
import { getChannelLabel } from 'data/channels/helpers'
import NoteIcon from 'components/Notes/Icon'
import RoutesHelper from 'helpers/RoutesHelper'

const breadcrumbClassName =
  'pointer no-wrap shade-20 shade-10-on-hover font-size-large'

export function Wrapper({ children }) {
  return (
    <div
      className={classNames(
        'flexbox flexbox-grow flexbox-align-center',
        'ellipsis',
        'slite-design-system font-weight-medium line-height-large padding-vertical-normal',
        'fs-block data-hj-suppress' /* fs-block & data-hj-suppress hides content for FullStory & Hotjar */
      )}
      style={{ minWidth: 0 }} // ensure ellipsis works for nested flex children
    >
      {children}
    </div>
  )
}

function Separator() {
  return <span className="padding-horizontal-small shade-30">{' / '}</span>
}

export function TemplateRoot() {
  return (
    <Link to={RoutesHelper.templates()} className={breadcrumbClassName}>
      Templates
    </Link>
  )
}

export function ChannelItem({ channel, isPrivate }) {
  return (
    <React.Fragment>
      {isPrivate && (
        <LockIcon
          size={12}
          className="margin-right-small shade-30 flexbox-no-shrink"
        />
      )}
      <Link
        to={RoutesHelper.noteChannelIndex({
          channelId: channel.id,
        })}
        className={breadcrumbClassName}
      >
        {getChannelLabel(channel)}
      </Link>
    </React.Fragment>
  )
}

export function NoteItem({ note, onClick }) {
  const title = note.title || 'Untitled'
  return (
    <React.Fragment>
      <Separator />
      <span className="shade-20">
        <NoteIcon
          iconShape={note.iconShape}
          iconColor={note.iconColor}
          hasChildren={note.hasChildren}
          className="margin-right-small flexbox-no-shrink"
        />
      </span>
      <Link
        title={title}
        to={RoutesHelper.noteChannelShow({
          noteId: note.id,
          channelId: note.channelId,
        })}
        className={classNames(breadcrumbClassName, 'ellipsis')}
        style={{ minWidth: 0 }}
        onClick={onClick}
      >
        {note.title || 'Untitled'}
      </Link>
    </React.Fragment>
  )
}

export const TemplateItem = function({ note }) {
  const title = note.title || 'Untitled'
  return (
    <React.Fragment>
      <span className="padding-horizontal-small shade-30">{' / '}</span>
      <span className="shade-20">
        <NoteIcon
          iconShape={note.iconShape}
          iconColor={note.iconColor}
          hasChildren={note.hasChildren}
          className="margin-right-small flexbox-no-shrink"
        />
      </span>
      <Link
        title={title}
        className={classNames(breadcrumbClassName, 'ellipsis')}
        style={{ minWidth: 0 }}
        to={RoutesHelper.templateShow({
          templateId: note.id,
        })}
      >
        {title}
      </Link>
    </React.Fragment>
  )
}
